import type { ProgramEventType } from 'models';

import { Button, Col, Row } from 'ui';
import CardOption from './CardOption';

type P = {
  onBack?: () => void;
  onChange: (eventType: ProgramEventType) => void;
  options: ProgramEventType[];
};

const TypeStepEventForm = ({ onBack, onChange, options }: P) => (
  <Row data-test-id="event_modal-event-type" gutter={['ms', 'ms']}>
    {options.includes('conference') && (
      <Col span={24}>
        <CardOption
          description={['Up to 64 participants total', 'Interactive mode: all can share camera and audio']}
          onChange={onChange}
          title="Video Conference"
          type="conference"
        />
      </Col>
    )}
    {options.includes('webinar') && (
      <Col span={24}>
        <CardOption
          description={[
            'Up to 64 admins/presenters with 1000 participants total',
            'Presentation mode: Attendees can view, hear, chat, etc.',
          ]}
          onChange={onChange}
          title="Webinar/Webcast"
          type="webinar"
        />
      </Col>
    )}
    {onBack ? (
      <Col justifyContent="flexEnd" span={24}>
        <Button onClick={onBack}>Back</Button>
      </Col>
    ) : null}
  </Row>
);

export default TypeStepEventForm;
